<div class="container vsp-container">
  @if (!isSummaryPage) {
    <app-header></app-header>
  }
  @if (!isSummaryPage) {
    <app-alert [sticky]="true"></app-alert>
  }
  <router-outlet></router-outlet>
  @if (!isSummaryPage) {
    <app-footer></app-footer>
  }
</div>
